import { Preloader } from "randmarcomps";
import React from "react";

interface IProps {
  text?: string;
  small?: boolean;
}

const LoadingComponent: React.FC<IProps> = ({ text, small }) => {
  return (
    <div className="flex flex-col justify-center items-center">
      <div className="mb-4">
        {small ? <span>{text || ""}</span> : <h2>{text || ""}</h2>}
      </div>
      <Preloader />
    </div>
  );
};

export default LoadingComponent;
